import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import "./index.scss";

export const ToolsStatusLevel1 = observer((props) => {
  const {
    status = "none",  // running, success, failed, waiting
    className = '',
  } = props;

  return (
    <div className={`tools-status tools-status-${status} ${className}`}>
      
    </div>
  )
});